import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterFull } from "../../../components/FooterFull";
import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { TaxDeduction } from "../../../components/TaxDeduction";
import { Modal } from "../../../components/Modal";

import * as main from "./styles/main.module.scss";
import * as screen1 from "./styles/screen1.module.scss";
import * as remember from "./styles/remember.module.scss";
import * as product from "./styles/product.module.scss";
import * as free from "./styles/free.module.scss";
import * as song from "./styles/song.module.scss";
import * as about from "./styles/about.module.scss";
import * as speaker from "./styles/speaker.module.scss";
const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel logo={"orange"} phoneColor={"#FFF"}/>
        <div className={screen1.mainDesc}>
          <h1>МИРОВЫЕ ХИТЫ</h1>
          <p className={screen1.desc}>
            Серия уроков английского по&nbsp;песням, <br/> основанная на&nbsp;методиках изучения языков Advance
          </p>
        </div>
        <div className={screen1.bottomBlock}>
          <div className={`row ${screen1.row}`}>
            <div className={`col ${screen1.col}`}>
              <div className={screen1.bottomBlockImg}>
                <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/love-english-1.png" alt=""/>
              </div>
              <h3 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red} ${main.fw900}`}>
                Мы любим <br/> живой английский,
              </h3>
              <p>
                на котором общаются <br/> миллионы людей
              </p>
            </div>
            <div className={`col ${screen1.col}`}>
              <div className={screen1.bottomBlockImg}>
                <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/love-english-2.png" alt=""/>
              </div>
              <h3 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red} ${main.fw900}`}>
                Мы мечтаем <br/> понимать смысл
              </h3>
              <p>
                новостей и&nbsp;фильмов <br/> без перевода и&nbsp;субтитров
              </p>
            </div>
            <div className={`col ${screen1.col}`}>
              <div className={screen1.bottomBlockImg}>
                <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/love-english-3.png" alt=""/>
              </div>
              <h3 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red} ${main.fw900}`}>
                Мы хотим заговорить <br/> на&nbsp;английском,
              </h3>
              <p>
                выбросив скучные <br/> учебники подальше
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
const Remember = () => {
  return (
    <section className={remember.remember}>
      <div className="container">
        <div className={`row ${remember.row}`}>
          <div className={`col-12 col-md-6 ${remember.col}`}>
            <h2 className={`${main.blockTitle} ${main.blockTitleLg}`}>
              <span className={`${main.unline} ${main.unlineRed} ${remember.unline}`}>Запоминаем</span>
            </h2>
            <h3 className={`${main.blockTitle} ${main.blockTitleSm}`}>
              <span className={main.red}>Популярные слова</span>
              <br/>
                И грамматические конструкции по&nbsp;текстам любимых песен!
            </h3>
            <p>
              Серия уроков «Мировые хиты» – это&nbsp;приятное и&nbsp;эффективное дополнение к&nbsp;изучению иностранного языка.
            </p>
          </div>
          <div className={`col-12 col-md-6 ${remember.col}`}>
            <div className={`${main.videoWrap} ${remember.lights}`}>
              <iframe
                className={`${main.video}`}
                src="https://www.youtube.com/embed/45LpZ03qQlM?rel=0&showinfo=0"
                title={"Музыкальный английский в Advance"}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Product = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={`${product.product} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleMd} ${main.fw900}`}>
          Выбирайте серию <span className={`${main.unline} ${main.unlineRed}`}>для своего уровня</span> и&nbsp;занимайтесь в&nbsp;удобное время
        </h2>
        <p className={product.topDesc}>
          Жмите на желтую кнопку, чтобы оформить подписку: <br/> 1&nbsp;урок каждую неделю в&nbsp;течение месяца!
        </p>
        <div className={`row ${product.row}`}>
          <div className={`col ${product.col}`}>
            <div className={product.imgBlock}>
              <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/select-1.png" alt=""/>
            </div>
            <div className={product.packDesc}>
              <h3 className={`${main.blockTitle} ${main.blockTitleMin} ${main.fw900}`}>
                <span className={main.red}>Новичок</span>
                <small>starter+</small>
              </h3>
              <p>Могу читать по-английски</p>
            </div>
            <button className={`btn ${main.blockBtn}`} onClick={()=>{setShowModal(true)}}>Знаю алфавит и могу читать</button>
          </div>
          <div className={`col ${product.col}`}>
            <div className={product.imgBlock}>
              <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/select-2.png" alt=""/>
            </div>
            <div className={product.packDesc}>
              <h3 className={`${main.blockTitle} ${main.blockTitleMin} ${main.fw900}`}>
                <span className={main.red}>Любитель</span>
                <small>Beginner+</small>
              </h3>
              <p>Знаю кое-что по-английски</p>
            </div>
            <button className={`btn ${main.blockBtn}`} onClick={()=>{setShowModal(true)}}>Готов поддержать простую беседу</button>
          </div>
          <div className={`col ${product.col}`}>
            <div className={product.imgBlock}>
              <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/select-3.png" alt=""/>
            </div>
            <div className={product.packDesc}>
              <h3 className={`${main.blockTitle} ${main.blockTitleMin} ${main.fw900}`}>
                <span className={main.red}>Бывалый</span>
                <small>Elementary+ / Pre-intermediate</small>
              </h3>
              <p>Понимаю английский</p>
            </div>
            <button className={`btn ${main.blockBtn}`} onClick={()=>{setShowModal(true)}}>Часто использую английский</button>
          </div>
        </div>
        <p className={`${main.blockTitle} ${main.blockTitleMd} ${main.fw900}`}>
          Стоимость 3 уроков:
          <del className={main.fw500}>
            990&nbsp;<span>&#8381;</span>
          </del>
          <span className={`${main.unline} ${main.unlineYellow} ${main.red}`}>
            580&nbsp;<span>&#8381;</span>
          </span>
        </p>
        <TaxDeduction margin={"20px 0 0"}/>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Free = () => {
  return (
    <section className={`${free.free} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleMd}`}>Что делать, если я&nbsp;<span className={`${main.unline} ${main.unlineRed}`}>не умею читать</span> по-английски?</h2>
        <p className={free.blockDesc}>Смотрите бесплатные уроки, подтяните свои знания, а после – смело приступайте к занятиям!</p>
        <div className={`row ${free.row}`}>
          <div className="col-12 col-md-6">
            <p className={free.videoDesc}>Урок «АНГЛИЙСКИЙ АЛФАВИТ»</p>
            <div className={main.videoWrap}>
              <iframe
                className={main.video}
                src="https://www.youtube.com/embed/dQ09pzfBlg8?rel=0&showinfo=0;"
                title={"Английский алфавит"}
              />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <p className={free.videoDesc}>Урок «ТРАНСКРИПЦИЯ АНГЛИЙСКОГО»</p>
            <div className={main.videoWrap}>
              <iframe
                className={main.video}
                src="https://www.youtube.com/embed/qaK-htT8058?rel=0&showinfo=0;"
                title={"Транскрипция английского"}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Song = () => {
  return (
    <section className={`${song.song} ${main.sec}`}>
      <div className="container">
        <div className={song.innerBlock}>
          <h2 className={`${main.blockTitle} ${main.blockTitleMd}`}>
            Почему работа с&nbsp;песнями&nbsp;– это&nbsp;<span className={`${main.unline} ${main.unlineRed}`}>эффективно?</span>
          </h2>
          <ul>
            <li className={song.item1}>
              <h4 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red}`}>Улучшается навык аудирования</h4>
              Прослушивание любого аудиоматериала&nbsp;– это&nbsp;работа над&nbsp;способностью воспринимать речь на&nbsp;слух.
            </li>

            <li className={song.item2}>
              <h4 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red}`}>Активно пополняется словарный запас</h4>
              Слова запоминаются легче благодаря рифме и&nbsp;ритму.
            </li>

            <li className={song.item3}>
              <h4 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red}`}>Правильное произношение копируется с&nbsp;многократного повторения</h4>
              Мы даем качественные примеры без фонетического искажения.
            </li>

            <li className={song.item4}>
              <h4 className={`${main.blockTitle} ${main.blockTitleMin} ${main.red}`}>В памяти сохраняются популярные грамматические формы</h4>
              Строчки из&nbsp;песен&nbsp;– это отличные модели для построения подобных по структуре предложений.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
const About = () => {
  return (
    <section className={`${about.about} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleMd} ${about.title}`}>
          Что включает в себя <span className={`${main.unline} ${main.unlineRed}`}>каждый урок?</span>
        </h2>
        <div className={`row ${about.row}`}>
          <div className={`col ${about.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/inc-translator.svg" alt=""/>
            <b className={`${main.blockTitle} ${main.blockTitleMin}`}>Текст песни</b>
            <p>
              и ее перевод
            </p>
          </div>
          <div className={`col ${about.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/inc-checklist.svg" alt=""/>
            <b className={`${main.blockTitle} ${main.blockTitleMin}`}>
              Список <br/> всех слов
            </b>
            <p>
              и технику их быстрого запоминания
            </p>
          </div>
          <div className={`col ${about.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/inc-algorithm.svg" alt=""/>
            <b className={`${main.blockTitle} ${main.blockTitleMin}`}>
              Разбор
            </b>
            <p>
              важной грамматической конструкции
            </p>
          </div>
          <div className={`col ${about.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/inc-excel.svg" alt=""/>
            <b className={`${main.blockTitle} ${main.blockTitleMin}`}>
              Паттерны
            </b>
            <p>
              для отработки  грамматики
            </p>
          </div>
          <div className={`col ${about.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/anglijskiy_po_pesnyam/inc-canvas.svg" alt=""/>
            <b className={`${main.blockTitle} ${main.blockTitleMin}`}>
              Творческое задание
            </b>
            <p>
              для осознанного пения
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
const Speaker = () => {
  return (
    <section className={`${speaker.speaker} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleMd}`}>
          <span className={`${main.unline} ${main.unlineRed}`}>Автор</span> уроков
        </h2>
        <div className={`row ${speaker.speaker__row}`}>
          <div className={speaker.speaker__imageBlock}>
            <div className={speaker.speaker__descWrapper}>
              <h3 className={speaker.speaker__descName}>Анна Вишнякова</h3>
              <p className={speaker.speaker__descProf}>Преподаватель английского языка</p>
            </div>
          </div>
          <ul className={speaker.speaker__list}>
            <li>Закончила Елабужский Педагогический Университет, факультет иностранных языков.</li>
            <li>Работает с&nbsp;английским и&nbsp;на английском с&nbsp;2006 года.</li>
            <li>Опытный педагог-организатор.</li>
            <li>Имеет за&nbsp;плечами многолетний стаж работы с&nbsp;детьми, из&nbsp;них 3&nbsp;года&nbsp;– в&nbsp;языковом лагере</li>
            <li>в Финляндии; высочайшие результаты своих учеников при подготовке к&nbsp;международным</li>
            <li>экзаменам, ЕГЭ, ГИА; работу со&nbsp;студентами в&nbsp;возрасте от&nbsp;5&nbsp;до 65&nbsp;лет: в&nbsp;дошкольных</li>
            <li>учреждениях, школе и&nbsp;на курсах.</li>
            <li>В Advance с&nbsp;2013 года, как:<br/>
              <br/>
                - Преподаватель английского языка.
              <br/>
                - Методист и автор материалов.
              <br/>
                - Тренер курса-интенсива «Английский за 7 дней».
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

const TITLE = 'Серия уроков английского языка по песням, основанная на методиках изучения языков «Advance»';
const DESCRIPTION = 'Серия уроков английского языка по песням, основанная на методиках изучения языков «Advance»';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'e144272b9e5658e294a48f7627edd2374766cb60'} id={'308827'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `'Roboto', sans-serif`, color: "#353535" }}>
      <Screen1/>
      <Remember/>
      <Product widget={widget}/>
      <Free/>
      <Song/>
      <About/>
      <Speaker/>
      <Product widget={widget}/>
    </main>

    <FooterFull/>

  </DefaultLayout>
);
export default Page;
